import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { SnackBarService } from 'src/app/shared';
import { environment } from 'src/environments/environment';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-create-template',
  templateUrl: './create-template.component.html',
  styleUrls: ['./create-template.component.scss']
})
export class CreateTemplateComponent implements OnInit {

  templateId:any;
  isEditingMode:boolean=false;
  emailTemplateData:any;
  createEmailTemplateForm:FormGroup

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '0',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' }
    ],
    customClasses: [
      {
        name: 'quote',
        class: 'quote',
      },
      {
        name: 'redText',
        class: 'redText'
      },
      {
        name: 'titleText',
        class: 'titleText',
        tag: 'h1',
      },
    ],
    uploadUrl: environment.mediaUploadUrl,
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['bold', 'italic'],
      ['fontSize']
    ]
  };

  constructor(
    private activatedRoute:ActivatedRoute,
    private notificationService: NotificationService,
    private router:Router,
    private snackbarService :SnackBarService
  ) { }

  ngOnInit() :void{
    this.initForms();
    this.setRouteParams();
  }

  setRouteParams(){
    this.activatedRoute.params.subscribe(params=>{
      this.templateId=params.id ? Number(params.id) : ''
    })
    if(this.templateId){
      this.isEditingMode=true
      this.getEmailTemplateDetail()
    }
  }

  initForms(){
    this.createEmailTemplateForm=new FormGroup({
      title:new FormControl('',Validators.required),
      subject:new FormControl('',Validators.required),
      content:new FormControl('')
    })
  }

  getEmailTemplateDetail(){
    this.emailTemplateData=''
    if(this.templateId){
      this.notificationService.getEmailTemplateDetail(this.templateId).subscribe(res=>{
            this.emailTemplateData=res
            this.setTemplateData();
         })
    }
  }

  setTemplateData(){
    if(this.emailTemplateData){
      this.createEmailTemplateForm.patchValue({
      title:this.emailTemplateData.title,
      subject:this.emailTemplateData.subject,
      content:this.emailTemplateData.content
      })
    }
  }

  createEmailTemplate(){
    if(!this.createEmailTemplateForm.valid){
      return
    }
    let filters={
      ...this.createEmailTemplateForm.value
    }
    if(this.isEditingMode){
      this.notificationService.editEmailTemplate(this.templateId,filters).subscribe(
      success=>{
        this.snackbarService.showSnack('Template Edited Successfuly.')
        this.router.navigate(["/notifications/templates"])
      },
      error => {
        this.snackbarService.showSnack(error.detail);
      }
      )
    }
    else{
      this.notificationService.createEmailTemplate(filters).subscribe(
        success=>{
        this.snackbarService.showSnack('Template Created Successfuly.')
        this.router.navigate(["/notifications/templates"])
        },
        error => {
        this.snackbarService.showSnack(error.detail);
        })
    }
   
  }

}
